<template>
  <b-list-group style="padding-top: 10px; padding-bottom: 10px;">
    <b-list-group-item
      v-for="file in files"
      :key="file.id"
      class="flex-column align-items-start"
      :href="file.url"
    >
      <div class="d-flex w-100 justify-content-between">
        <p class="mb-1 text-primary">
          {{ file.name }}
        </p>
      </div>

      <p
        v-if="file.description"
        class="mb-1 mt-1"
      >
        {{ file.description }}
      </p>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FileSection',
  props: {
    id: {
      type: Number,
      default: -1
    }
  },
  data: () => {
    return {}
  },
  computed: {
    ...mapGetters([
      'getSectionById'
    ]),
    section () {
      return this.getSectionById(this.id)
    },
    files () {
      const f = JSON.parse(this.section.content)
      return f.filter(x => x != null)
    }
  }
}
</script>

<style scoped>

</style>
